import {
  PATH_NAME_COIN_CHARGE_FOR_DCB, PATH_NAME_REVOCATION_DEFENSE,
  PATH_NAME_VOUCHER_INDEX,
  PATH_NAME_VOUCHER_POOQZONE, PATH_NAME_VOUCHER_PROMOTION,
  PATH_NAME_VOUCHER_REGIST
} from '@/common/resources/router.const'
import _ from 'lodash'
export default [
  {
    path: 'voucher',
    components: {
      voucherLayout: () => import('@/pages/section/VoucherLayout')
    },
    children: [
      {
        path: '',
        name: PATH_NAME_VOUCHER_INDEX,
        meta: { menu: 'index' },
        alias: ['index.html', 'index', '/'],
        components: {
          voucherContent: () => import(/* webpackChunkName: "voucher_index" */'@/pages/voucher')
        }
      },
      {
        path: 'regist',
        name: PATH_NAME_VOUCHER_REGIST,
        meta: { menu: 'regist' },
        alias: 'regist.html',
        components: {
          voucherContent: () => import(/* webpackChunkName: "voucher_regist" */'@/pages/voucher/regist')
        }
      },
      {
        path: 'wavveon',
        name: PATH_NAME_VOUCHER_POOQZONE,
        meta: { menu: 'wavveon' },
        alias: 'wavveon.html',
        components: {
          voucherContent: () => import(/* webpackChunkName: "voucher_pooqzone" */'@/pages/voucher/pooqzone')
        }
      },
      {
        path: 'promotion',
        name: PATH_NAME_VOUCHER_PROMOTION,
        meta: { name: 'voucher_promotion' },
        alias: 'promotion.html',
        components: {
          voucherContent: () => import(/* webpackChunkName: "voucher_promotion" */'@/pages/voucher/voucher_promotion')
        }
      }
    ]
  },
  // 이용권 해더 미포함
  {
    path: 'voucher/dcbcoin',
    name: PATH_NAME_COIN_CHARGE_FOR_DCB,
    alias: '/voucher/dcbcoin.html',
    components: {
      voucherLayout: () => import('@/pages/voucher/dcbcoin.vue')
    }
  },
  {
    path: 'voucher/revocation_defense',
    name: PATH_NAME_REVOCATION_DEFENSE,
    alias: '/voucher/revocation_defense.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "revocation_defense" */'@/pages/voucher/revocation_defense')
    }
  }
]
